// Institute of Design and Innovation (email idi@unm.edu). //

import Permission from '@/models/permission'
import { createStore } from 'vuex'
import State from './state'

/**
 * Create storage for state values
 */
export default createStore<State>({
  state: {
    userId: null as unknown as number,
    firstName: '',
    lastName: '',
    sessionExpiration: null as unknown as number,
    accessExpiration: null as unknown as number,
    isAdmin: false,
    permissions: [] as Array<Permission>,
    outlookUserId: ''
  },

  getters: {
    userId: state => state.userId,
    firstName: state => state.firstName,
    lastName: state => state.lastName,
    fullName: state => `${state.firstName} ${state.lastName}`,
    userIdPlus: state => state.userId + ' plus',
    sessionExpiration: state => state.sessionExpiration,
    accessExpiration: state => state.accessExpiration,
    permissionValue: state => state.permissions.map(pv => pv.permissionValue).reduce((pv, c) => pv | c),
    outlookUserId: state => state.outlookUserId,
    outlookEnabled: state => state.outlookUserId !== '' && state.outlookUserId != null,
    isReadOnly: state => state.permissions.findIndex(p => p.code === 'VIEW') !== -1,
    isReviewer: state => state.permissions.findIndex(p => p.code === 'REVU') !== -1,
    isAdmin: state => state.permissions.findIndex(p => p.code === 'ADMN') !== -1
  },

  mutations: {
    /** Mutation to initialize a user state on login */
    initializeState (state, newState: State) {
      Object.assign(state, newState)
    }
  },

  actions: {
    /** initialize session */
    initializeSession ({ commit }, state: State) {
      commit('initializeState', state)
    }
  }
})
